module.exports = __webpack_public_path__ + "img/long_jump_card.234ae77f.svg";